export const PLAYER_FSM_SLICE_KEY = 'player-fsm' as const;
